import _ from "lodash";
import DailyMenuOptionOrder from "@/model/dailymenu/DailyMenuOptionOrder";


export default class MenuGroupItem {
    private constructor (
        readonly id:string,
        readonly title: string,
        readonly kind: string,
        readonly subGroupList: MenuGroupItem[],
        readonly optionList: DailyMenuOptionOrder[],
        readonly tags: string[]
    ) {}

    get menuOptionOffered (): any | undefined {
        return _.find(this.optionList,(option:DailyMenuOptionOrder) => {
            return option.offer
        } )

    }

    get selectedOption (): DailyMenuOptionOrder | undefined {
        return _.find(this.optionList,(option:DailyMenuOptionOrder) => {
            return option.isSelected
        } )

    }

    static createFromList (responseData: any[]): MenuGroupItem[] {
        return responseData.map( (value:any):MenuGroupItem => MenuGroupItem.createDailyMenuInterface(value))
    }

    static createDailyMenuInterface (responseData: any): MenuGroupItem {
        return new MenuGroupItem(
            responseData.id,
            responseData.title,
            responseData.kind,
            responseData.subGroups ? MenuGroupItem.createFromList(responseData.subGroups):[],
            responseData.slots ? DailyMenuOptionOrder.createFromResponse(responseData.slots):[],
            responseData.tags

        )
    }
}